/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `thumbs_up` - Thumbs Up * `check` - Check * `eyes` - Eyes * `heart` - Heart
 */

export const EmojiEnum = {
  ThumbsUp: "thumbs_up",
  Check: "check",
  Eyes: "eyes",
  Heart: "heart",
} as const;

export type EmojiEnum = (typeof EmojiEnum)[keyof typeof EmojiEnum];
